import { Container, Row, Col } from "react-bootstrap";
import ProductList from "../Product/ProductList";

const Products = () => {
  return (
    <>
      <Container>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <h1 className="text-left hover-underline">All Products</h1>
          </Col>
        </Row>
      </Container >
      <ProductList />
    </>
  );
}

export default Products;